import { ReferralGuard } from './referral.guard';
import { RedirectGuard } from './redirect.guard';
import { AccountSelectorGuard } from './account-selector.guard';
import { SetPasswordTokenGuard } from './set-password-token.guard';
import { ChangeEmailTokenGuard } from './change-email-token.guard';
import { CancelChangeEmailTokenGuard } from './cancel-change-email-token.guard';
import { UnusualActivityGuard } from './unusual-activity.guard';
import { VerifyLoginGuard } from './verify-login.guard';
import { VerifyEmailResolve } from '../resolves/verify-email.resolve';

export const guards: any[] = [
  ReferralGuard,
  RedirectGuard,
  AccountSelectorGuard,
  SetPasswordTokenGuard,
  ChangeEmailTokenGuard,
  CancelChangeEmailTokenGuard,
  UnusualActivityGuard,
  VerifyLoginGuard,
  VerifyEmailResolve,
];

export * from './referral.guard';
export * from './redirect.guard';
export * from './account-selector.guard';
export * from './set-password-token.guard';
export * from './change-email-token.guard';
export * from './cancel-change-email-token.guard';
export * from './unusual-activity.guard';
export * from './verify-login.guard';
export * from '../resolves/verify-email.resolve';
